import { useTranslation } from "react-i18next";
import TabsComponent from "../../../../components/tabs/TabsComponent";
import { ReceivedTab } from "./ReceivedTab";
import { OutGoingTab } from "./OutGoingTab";
import { makeApiRequest, showApiErrorMessages } from "../../../../helpers";
import { showApologizeRequests } from "../../../../api/endpoints/students/requests";
import RequestsModel from "../../../../api/models/RequestsModel";
import { ApiResponse } from "../../../../api/apiResponse";
import { useEffect, useState } from "react";

export default function RequestsStudentInfo() {
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [requestsReceived, setRequestsReceived] = useState<RequestsModel[]>([]);
  const [requestsOutGoing, setRequestsOutGoing] = useState<RequestsModel[]>([]);

  const showRequests = async () => {
    await makeApiRequest(
      () =>
        showApologizeRequests({
          filters: { sender_type: "Tutor", order_by: "-created_at" },
        }),
      (response: ApiResponse) => {
        if (response.isSuccess) {
          const { data } = response;
          const requestsList: RequestsModel[] = RequestsModel.fromApiResponse(
            data,
            "receiver"
          );
          setRequestsReceived(requestsList);
        } else {
          showApiErrorMessages(response);
        }
      }
    );
  };

  const showRequestsOutGoing = async () => {
    await makeApiRequest(
      () =>
        showApologizeRequests({
          filters: { sender_type: "Student", order_by: "-created_at" },
        }),
      (response: ApiResponse) => {
        if (response.isSuccess) {
          const { data } = response;
          const requestsList: RequestsModel[] = RequestsModel.fromApiResponse(
            data,
            "sender"
          );
          setRequestsOutGoing(requestsList);
        } else {
          showApiErrorMessages(response);
        }
      }
    );
  };
  useEffect(() => {
    showRequests();
    showRequestsOutGoing();
  }, []);
  const tabs = [
    {
      name: t("received"),
      content: <ReceivedTab requests={requestsReceived} />,
      counter: requestsReceived.length,
    },
    {
      name: t("outgoing"),
      content: <OutGoingTab requests={requestsOutGoing} />,
      counter: requestsOutGoing.length,
    },
  ];
  return (
    <div className="flex flex-col w-full bg-gray-50 ">
      <div>
        <h1 className="px-8 mt-2 mb-4 text-2xl font-semibold text-gray-900 ">
          {t("apologizeSession")}
        </h1>
      </div>
      <TabsComponent requests={true} tabs={tabs} />
    </div>
  );
}
